export class PlayersService {
    constructor(httpService) {
        this.httpService = httpService;
    }
    async overrideIdentity(roomId, playerId) {
        const response = await this.httpService.get(`player/${roomId}/${playerId}/override`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al sobreescribir la identidad del jugador.');
        }
    }
}
